const routes = [
  {
    path: "/perfis-dados",
    name: "perfil-dados-list",
    meta: {
      allowedPermissions: ["perfil_list"],
    },
    component: () => import("@/views/PerfilDados/ListView.vue"),
  },
  {
    path: "/perfis-dados/novo",
    name: "perfil-dados-add",
    meta: {
      allowedPermissions: ["perfil_list"],
    },
    component: () => import("@/views/PerfilDados/AddView.vue"),
  },
  {
    path: "/perfis-dados/:id/editar",
    name: "perfil-dados-edit",
    meta: {
      allowedPermissions: ["perfil_list"],
    },
    component: () => import("@/views/PerfilDados/EditView.vue"),
  },
  {
    path: "/perfis-dados/:id/usuarios",
    name: "perfil-dados-usuarios",
    meta: {
      allowedPermissions: ["perfil_list"],
    },
    component: () => import("@/views/PerfilDados/ListUsuariosView.vue"),
  },
];

export default routes;
